import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
  title: {
    id: 'knowledgeBase.title',
    defaultMessage: 'Knowledge Base',
  },
  loadError: {
    id: 'knowledgeBase.loadError',
    defaultMessage: 'Failed to load the knowledge base.',
  },
  articleError: {
    id: 'knowledgeBase.articleError',
    defaultMessage: 'Failed to load this article.',
  },
  retry: {
    id: 'knowledgeBase.retry',
    defaultMessage: 'Retry',
  },
  close: {
    id: 'knowledgeBase.close',
    defaultMessage: 'Close',
  },
  menu: {
    id: 'knowledgeBase.menu',
    defaultMessage: 'Sections',
  },
  language: {
    id: 'knowledgeBase.language',
    defaultMessage: 'Language',
  },
  market: {
    id: 'knowledgeBase.market',
    defaultMessage: 'Market',
  },
  autoLanguage: {
    id: 'knowledgeBase.autoLanguage',
    defaultMessage: 'Auto',
  },
  open: {
    id: 'knowledgeBase.open',
    defaultMessage: 'Open knowledge base',
  },
  chooseArticle: {
    id: 'knowledgeBase.chooseArticle',
    defaultMessage: 'Choose an article from the list.',
  },
  kbRelated: {
    id: 'knowledgeBase.related',
    defaultMessage: 'Related',
  },
  note: {
    id: 'knowledgeBase.note',
    defaultMessage: 'Note',
  },
  contents: {
    id: 'knowledgeBase.contents',
    defaultMessage: 'Contents',
  },
  backToPage: {
    id: 'knowledgeBase.backToPage',
    defaultMessage: 'Back to the lesson',
  },
  video: {
    id: 'knowledgeBase.video',
    defaultMessage: 'Video',
  },
  playbackControls: {
    id: 'knowledgeBase.playbackControls',
    defaultMessage: 'Playback controls',
  },
  imageViewer: {
    id: 'knowledgeBase.imageViewer',
    defaultMessage: 'Image',
  },
  openDocument: {
    id: 'knowledgeBase.openDocument',
    defaultMessage: 'Open',
  },
  downloadDocument: {
    id: 'knowledgeBase.downloadDocument',
    defaultMessage: 'Download',
  },
});
